import React, { useEffect, useRef, useState } from "react";
import "./PreviewPage.css";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
//import axios from "axios";
import { getEmployeeDetailsBasedonEmployeeUniqueeId, getMobileOtpPreview, mobileVerifyOtp, getEmailOtpPreview, emailVerifyOtp, personalInfoCompleteSubmit } from "../../../../../../services/employeeCreationService";
import { getAuditLog } from "../../../../../../utils/calculateDaysInMonthUtils";
import useOtpTimer from "../../../../../../hooks/useOtpTimer"; // ✅ Import custom hook
import { getFileName } from "../../../../../../utils/validations";
import jsPDF from "jspdf";
import "jspdf-autotable";
const PreviewPage = ({ onPrevious }) => {
    const effectRan = useRef(false);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const employeeUniqueId =
        searchParams.get("employeeUniqueId") || location.state?.applicationId;
    const [previewData, setPreviewDetails] = useState(null);
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [emailOtp, setEmailOtp] = useState("");
    const [mobileOtp, setMobileOtp] = useState("");
    const [emailSent, setEmailSent] = useState(false);
    const [mobileSent, setMobileSent] = useState(false);
    // state initialization (make sure to set based on previewData)
    const [verified, setVerified] = useState(previewData?.emailVerified || false);
    const [mobileVerified, setMobileVerified] = useState(previewData?.mobileVerified || false);

    // const [emailTimer, setEmailTimer] = useState(0); // countdown seconds
    //const [mobileTimer, setMobileTimer] = useState(0); // countdown for mobile OTP
    const navigate = useNavigate();
    const [showSaveSuccess, setShowSaveSuccess] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const { timer: emailTimer, startTimer: startEmailTimer } = useOtpTimer(60);
    const { timer: mobileTimer, startTimer: startMobileTimer } = useOtpTimer(60);
    const [isChecked, setIsChecked] = useState(false);

    // === SEND OTP ===
    const sendMobileOtp = async (e) => {
        e.preventDefault(); // stop form navigation
        try {

            const res = await getMobileOtpPreview(employeeUniqueId);

            console.log("OTP Sent:", res.data);
            setMobileSent(true);
            startMobileTimer();
            alert("OTP sent to your Mobile!");
        } catch (err) {
            console.error(err);
            alert("Failed to send OTP!");
        }
    };



    // === VERIFY OTP ===
    const verifyMobileOtp = async (e) => {
        e.preventDefault(); // stop navigation
        try {
            const payload = {
                destination: previewData.contactNumber, // <- use 'destination'
                otp: mobileOtp,
                type: "MOBILE",
            };


            const res = await mobileVerifyOtp(payload);
            console.log("Mobile OTP Verified:", res.data);
            setMobileVerified(true); // ✅ correct state for mobile
            setMobileOtp("");        // clear OTP input
            alert("Mobile verified successfully!");
        } catch (err) {
            console.error(err.response?.data || err);
            alert("Invalid Mobile OTP!");
        }
    };



    // === SEND OTP ===
    const sendEmailOtp = async (e) => {
        e.preventDefault(); // stop form navigation
        try {
            //const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/generate/${employeeUniqueId}?type=EMAIL`);
            const res = await getEmailOtpPreview(employeeUniqueId);
            console.log("OTP Sent:", res.data);
            setEmailSent(true);
            startEmailTimer(); //
            alert("OTP sent to your email!");
        } catch (err) {
            console.error(err);
            alert("Failed to send OTP!");
        }
    };

    // === VERIFY OTP ===
    const verifyEmailOtp = async (e) => {
        e.preventDefault(); // stop navigation
        try {
            const payload = {
                destination: previewData.email, // <- use 'destination'
                otp: emailOtp,
                type: "EMAIL",
            };

            const res = await emailVerifyOtp(payload);
            console.log("OTP Verified:", res.data);
            setVerified(true);
            alert("Email verified successfully!");
        } catch (err) {
            console.error(err.response?.data || err);
            alert("Invalid OTP!");
        }
    };

    // sync with API data (important!)
    useEffect(() => {
        if (previewData) {
            setVerified(previewData.emailVerified || false);
            setMobileVerified(previewData.mobileVerified || false);
        }
    }, [previewData]);

    useEffect(() => {
        const fetchData = async () => {
            try {

                const appData = await getEmployeeDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
                console.log("Fetched data:", appData);
                setPreviewDetails(appData);
            } catch (error) {
                console.error("Error fetching personal info:", error);
            }
        };
        if (!effectRan.current) {
            fetchData();
        }
        return () => {
            effectRan.current = true;
        }

    }, [employeeUniqueId]);

    //if (!previewData) return <div>Loading...</div>;
    // === SUBMIT FORM ===
    const handleSubmit = async (e) => {
        e.preventDefault(); // prevent page reload
        if (!verified) {
            alert("Please verify your email before submitting!");
            return;
        }

        try {
            const fullName = localStorage.getItem("full_name");
            const role = localStorage.getItem("role");
            const employeeId = localStorage.getItem("employeeId");
            const payload = {
                employeeUniqueId: employeeUniqueId,

                auditLog: getAuditLog(),
            };

            const res = await personalInfoCompleteSubmit(payload);
            setSuccessMessage("Your data successfully submitted. Do you want to download the PDF document?");
            setShowSaveSuccess(true);
            setIsSaved(true);

        } catch (err) {
            console.error(err.response?.data || err);
            alert("Submission failed!");
        }
    };

    const getOriginalFileName = (fullPath) => {
        if (!fullPath) return "-";
        const fileName = fullPath.split("/").pop();
        const firstHyphenIndex = fileName.search(/-[\d]/);
        if (firstHyphenIndex === -1) return fileName;
        return fileName.slice(0, firstHyphenIndex) + fileName.slice(fileName.lastIndexOf("."));
    };
    const getBase64ImageFromURL = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.setAttribute("crossOrigin", "anonymous"); // This is the KEY fix for CORS
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png");
                resolve(dataURL);
            };
            img.onerror = (error) => reject(error);
            img.src = url;
        });
    };
    const handleDownloadPdf = async () => {
        const doc = new jsPDF();
        if (previewData?.employeeIDDetails?.employeepassportSizeFileName) {
            try {
                const imgUrl = previewData.employeeIDDetails.employeepassportSizeFileName.startsWith("http")
                    ? previewData.employeeIDDetails.employeepassportSizeFileName
                    : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.employeepassportSizeFileName}`;

                const base64Img = await getBase64ImageFromURL(imgUrl);

                // doc.addImage(imageData, format, x, y, width, height)
                doc.addImage(base64Img, "PNG", 150, 25, 40, 40);
            } catch (err) {
                console.error("Could not add image to PDF due to CORS or path:", err);
            }
        }
        // --------------------------------------------------------------
        // 0. Global page settings
        // --------------------------------------------------------------
        const pageWidth = doc.internal.pageSize.getWidth();
        const leftMargin = 14;                 // <-- SAME for every table
        const rightMargin = 14;
        const usableWidth = pageWidth - leftMargin - rightMargin;

        doc.setFontSize(18);
        doc.text("Employee Profile", leftMargin, 15);
        doc.setFontSize(10);


        let startY = 25;   // first table starts here

        // --------------------------------------------------------------
        // Helper – create a table with a merged blue title
        // --------------------------------------------------------------
        const addTable = (options) => {
            doc.autoTable({
                startY,
                margin: { left: leftMargin, right: rightMargin },
                ...options,
            });
            startY = doc.lastAutoTable.finalY + (options.gapAfter ?? 8);
        };

        // --------------------------------------------------------------
        // 1. PERSONAL DETAILS – 4-column → 2-column layout
        // --------------------------------------------------------------
        const personalPairs = [
            ["First Name", previewData?.givenName || "-", "Last Name", previewData?.surname || "-"],
            ["Gender", previewData?.gender?.gender || "-", "Date of Birth",
                previewData?.dateOfBirth
                    ? new Intl.DateTimeFormat("en-GB")
                        .format(new Date(previewData.dateOfBirth))
                        .replace(/\//g, "-")
                    : "-"],
            ["Mobile", previewData?.contactNumber || "-", "Email", previewData?.email || "-"],
            ["Marital Status", previewData?.maritalStatus?.maritalStatus || "-", "Spouse Contact", previewData?.spouseContactNumber || "-"],
            ["Spouse Given Name", previewData?.spouseName || "-", "Spouse Surname", previewData?.spouseSurname || "-"],
            ["Father Given Name", previewData?.fatherGivenName || "-", "Father Surname", previewData?.fatherSurname || "-"],
            ["Mother Given Name", previewData?.motherGivenName || "-", "Mother Surname", previewData?.motherSurname || "-"],
            ["Father Mobile", previewData?.fatherContactNumber || "-", "Mother Mobile", previewData?.motherContactNumber || "-"],
            ["Nationality", previewData?.nationality?.nationalityName || "-", "Religion", previewData?.religion?.religionName || "-"],
            ["Reservation Category", previewData?.reservationCategory?.categoryName || "-", "Physically Handicapped", previewData?.physicallyHandicapped ? "Yes" : "No"],
            ["Hearing Problem", previewData?.hearingProblem ? "Yes" : "No", "Visual Problem", previewData?.visualProblem ? "Yes" : "No"],
        ];

        addTable({
            head: [["Personal Details", ""]],               // only 2 cells → 2 columns
            body: personalPairs,
            theme: "grid",
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: { fillColor: [0, 123, 255], textColor: 255, fontStyle: "bold", halign: "left" },
            columnStyles: {
                0: { fontStyle: "bold", cellWidth: 40 },
                1: { cellWidth: usableWidth - 40 },
            },
            didParseCell: (data) => {
                if (data.section === "head" && data.column.index === 0) {
                    data.cell.colSpan = 2;                 // merge title across both columns
                    data.cell.styles.halign = "left";
                }
            },
            gapAfter: 12,
        });

        // --------------------------------------------------------------
        // 2. ADDRESS – side-by-side Present / Permanent
        // --------------------------------------------------------------
        if (previewData?.addresses?.length > 0) {
            const a = previewData.addresses[0];
            const addressRows = [
                ["Address 1", a.presentAddressLine1 || "-", "Address 1", a.permanentAddressLine1 || "-"],
                ["Address 2", a.presentAddressLine2 || "-", "Address 2", a.permanentAddressLine2 || "-"],
                ["Country", a.presentCountry || "-", "Country", a.permanentCountry || "-"],
                ["State", a.presentState || "-", "State", a.permanentState || "-"],
                ["District", a.presentDistrict || "-", "District", a.permanentDistrict || "-"],
                ["Block / Mandal", a.presentBlock || a.presentMandal || "-", "Block / Mandal", a.permanentBlock || a.permanentMandal || "-"],
                ["Pincode", a.presentPostCode || "-", "Pincode", a.permanentPostCode || "-"],
            ];

            addTable({
                head: [["Present Address", "", "Permanent Address", ""]], // 4 cells → 4 columns
                body: addressRows,
                theme: "grid",
                styles: { fontSize: 10, cellPadding: 3 },
                headStyles: { fillColor: [0, 123, 255], textColor: 255, fontStyle: "bold", halign: "center" },
                columnStyles: {
                    0: { fontStyle: "bold", cellWidth: 35 },
                    1: { cellWidth: (usableWidth - 70) / 2 },
                    2: { fontStyle: "bold", cellWidth: 35 },
                    3: { cellWidth: (usableWidth - 70) / 2 },
                },
                didParseCell: (data) => {
                    if (data.section === "head") {
                        // merge the two title cells into ONE blue bar
                        if (data.row.index === 0 && data.column.index === 0) {
                            data.cell.colSpan = 4;
                            data.cell.text = "Address Details";
                            data.cell.styles.halign = "left";
                        }
                    }
                },
                gapAfter: 40,
            });
        }

        // --------------------------------------------------------------
        // 3. EDUCATION – 7-column compact table
        // --------------------------------------------------------------
        if (previewData?.educations?.length > 0) {
            const eduRows = previewData.educations.map(e => [
                e.qualification?.qualificationName || "-",
                e.degreeType?.degreeType || "-",
                e.specialization || "-",
                e.institutionName || "-",
                e.gradeOrPercentage || "-",
                e.yearOfPassing || "-",
                getOriginalFileName(e.certificate) || "-",
            ]);

            addTable({
                head: [
                    ["Education Details", "", "", "", "", "", ""],               // blue title
                    ["Qualification", "Degree / Exam", "Specializtion", "Institution", "Grade / Percentage", "Year", "Certificate"]
                ],
                body: eduRows,
                theme: "grid",
                styles: { fontSize: 10, cellPadding: 2 },
                columnStyles: {
                    0: { cellWidth: 25 }, 1: { cellWidth: 24 }, 2: { cellWidth: 28 },
                    3: { cellWidth: 35 }, 4: { cellWidth: 23 }, 5: { cellWidth: 14 },
                    6: { cellWidth: 30 },
                },
                didParseCell: (data) => {
                    if (data.section === "head") {
                        // ---- blue title row (merged) ----
                        if (data.row.index === 0 && data.column.index === 0) {
                            data.cell.colSpan = 7;
                            data.cell.styles.fillColor = [0, 123, 255];
                            data.cell.styles.textColor = 255;
                            data.cell.styles.fontStyle = "bold";
                            data.cell.styles.halign = "left";
                        }
                        // ---- white sub-header row (black bold) ----
                        if (data.row.index === 1) {
                            data.cell.styles.fillColor = [255, 255, 255];
                            data.cell.styles.textColor = 0;
                            data.cell.styles.fontStyle = "bold";
                            data.cell.styles.halign = "center";
                        }
                    }
                },
                gapAfter: 8,
            });
        }

        // --------------------------------------------------------------
        // 4. OTHER CERTIFICATES – 5-column table
        // --------------------------------------------------------------
        if (previewData?.certificates?.length > 0) {
            const certRows = previewData.certificates.map(c => [
                c.certificateName || "-",
                c.certificateNumber || "-",
                c.issuedDate || "-",
                c.validateDate || "-",
                getOriginalFileName(c.certificateFileName) || "-",
            ]);

            addTable({
                head: [
                    ["Other Certificates", "", "", "", ""],
                    ["Certificate Name", "Number", "Issued Date", "Valid Till", "File"]
                ],
                body: certRows,
                theme: "grid",
                styles: { fontSize: 10, cellPadding: 2 },
                columnStyles: {
                    0: { cellWidth: 38 }, 1: { cellWidth: 36 }, 2: { cellWidth: 38 },
                    3: { cellWidth: 38 }, 4: { cellWidth: 30 },
                },
                didParseCell: (data) => {
                    if (data.section === "head") {
                        if (data.row.index === 0 && data.column.index === 0) {
                            data.cell.colSpan = 5;
                            data.cell.styles.fillColor = [0, 123, 255];
                            data.cell.styles.textColor = 255;
                            data.cell.styles.fontStyle = "bold";
                            data.cell.styles.halign = "left";
                        }
                        if (data.row.index === 1) {
                            data.cell.styles.fillColor = [255, 255, 255];
                            data.cell.styles.textColor = 0;
                            data.cell.styles.fontStyle = "bold";
                            data.cell.styles.halign = "center";
                        }
                    }
                },
                gapAfter: 12,
            });
        }

        // --------------------------------------------------------------
        // 5. EXPERIENCE – 8-column table
        // --------------------------------------------------------------
        if (previewData?.experiences?.length > 0) {
            const expRows = previewData.experiences.map(e => [
                e.companyName || "-",
                e.designationName || "-",
                e.skillSet || "-",
                e.fromDate ? new Intl.DateTimeFormat("en-GB").format(new Date(e.fromDate)).replace(/\//g, "-") : "-",
                e.toDate ? new Intl.DateTimeFormat("en-GB").format(new Date(e.toDate)).replace(/\//g, "-") : "-",
                e.salaryDrawn || "-",
                getOriginalFileName(e.appointmentLetter) || "-",
                getOriginalFileName(e.relievingLetter) || "-",
            ]);

            addTable({
                head: [
                    ["Experience Details", "", "", "", "", "", "", ""],
                    ["Company Name", "Designation", "Skill Set", "From Date", "To Date", "Salary Drawn", "Appointment Letter", "Relieving Letter"]
                ],
                body: expRows,
                theme: "grid",
                styles: { fontSize: 10, cellPadding: 2 },
                columnStyles: {
                    0: { cellWidth: 28 }, 1: { cellWidth: 20 }, 2: { cellWidth: 20 },
                    3: { cellWidth: 20 }, 4: { cellWidth: 20 }, 5: { cellWidth: 20 },
                    6: { cellWidth: 25 }, 7: { cellWidth: 28 },
                },
                didParseCell: (data) => {
                    if (data.section === "head") {
                        if (data.row.index === 0 && data.column.index === 0) {
                            data.cell.colSpan = 8;
                            data.cell.styles.fillColor = [0, 123, 255];
                            data.cell.styles.textColor = 255;
                            data.cell.styles.fontStyle = "bold";
                            data.cell.styles.halign = "left";
                        }
                        if (data.row.index === 1) {
                            data.cell.styles.fillColor = [255, 255, 255];
                            data.cell.styles.textColor = 0;
                            data.cell.styles.fontStyle = "bold";
                            data.cell.styles.halign = "center";
                        }
                    }
                },
                gapAfter: 8,
            });
        }

        // --------------------------------------------------------------
        // 6. BANK DETAILS – 2-column layout
        // --------------------------------------------------------------
        if (previewData?.bankDetails?.length > 0) {
            const b = previewData.bankDetails[0];
            const bankPairs = [
                ["Account Holder", b.accountHolderName || "-"],
                ["Account Number", b.accountNumber || "-"],
                ["Account Type", b.accountType?.accountTypeName || "-"],
                ["Bank Name", b.bankName || "-"],
                ["Branch Name", b.branchName || "-"],
                ["IFSC Code", b.ifscCode || "-"],
                ["Passbook", getOriginalFileName(b.passbookFileName) || "-"],
            ];

            addTable({
                head: [["Bank Details", ""]],                // 2 cells → 2 columns
                body: bankPairs,
                theme: "grid",
                styles: { fontSize: 10, cellPadding: 3 },
                headStyles: { fillColor: [0, 123, 255], textColor: 255, fontStyle: "bold", halign: "left" },
                columnStyles: {
                    0: { fontStyle: "bold", cellWidth: 40 },
                    1: { cellWidth: usableWidth - 40 },
                },
                didParseCell: (data) => {
                    if (data.section === "head" && data.column.index === 0) {
                        data.cell.colSpan = 2;
                        data.cell.styles.halign = "left";
                    }
                },
                gapAfter: 12,
            });
        }

        // --------------------------------------------------------------
        // 7. EMPLOYEE ID DETAILS – 2-column layout
        // --------------------------------------------------------------
        if (previewData?.employeeIDDetails) {
            const id = previewData.employeeIDDetails;
            const idPairs = [
                ["Aadhaar Number", id.aadhaarNumber || "-"],
                ["Name as per Aadhaar", id.nameAsPerAadhaar || "-"],
                ["Aadhaar Photo", getOriginalFileName(id.aadhaarFileName) || "-"],
                ["PAN Number", id.panCardNumber || "-"],
                ["Name as per PAN", id.nameAsPerPanCard || "-"],
                ["PAN Photo", getOriginalFileName(id.panCardFileName) || "-"],
            ];

            // ---- UAN / ESI conditional ----
            if (!id.hasUanNumber && !id.hasEsiNumber) {
                idPairs.push(["UAN ?", "No"], ["ESI ?", "No"]);
            } else {
                if (id.hasUanNumber) {
                    idPairs.push(
                        ["UAN Number", id.uanNumber || "-"],
                        ["UAN Member ID", id.uanMemberId || "-"],
                        ["UAN Photo", getOriginalFileName(id.uanCardFileName) || "-"]
                    );
                }
                if (id.hasEsiNumber) {
                    idPairs.push(
                        ["ESI Number", id.esiNumber || "-"],
                        ["ESI Photo", getOriginalFileName(id.esiCardFileName) || "-"]
                    );
                }
            }

            // ---- Nominee & proofs ----
            idPairs.push(
                ["Nominee Name", id.nomineeName || "-"],
                ["Relationship", id.nomineeRelationship?.relationshipName || "-"],
                ["Staying with you?", id.isNomineeStayingWithYou ? "Yes" : "No"],
                ["Father ID Proof", getOriginalFileName(id.fatherIdProof) || "-"],
                ["Mother ID Proof", getOriginalFileName(id.motherIdProof) || "-"],
                ["Spouse ID Proof", getOriginalFileName(id.spouseIdProof) || "-"],
                ["PWD Certificate", getOriginalFileName(id.pwdCertificate) || "-"],
                ["Passport Size Photo", getOriginalFileName(id.employeepassportSizeFileName) || "-"]
            );

            addTable({
                head: [["Employee ID Details", ""]],          // 2 cells → 2 columns
                body: idPairs,
                theme: "grid",
                styles: { fontSize: 10, cellPadding: 2 },
                headStyles: { fillColor: [0, 123, 255], textColor: 255, fontStyle: "bold", halign: "left" },
                columnStyles: {
                    0: { fontStyle: "bold", cellWidth: 40 },
                    1: { cellWidth: usableWidth - 40 },
                },
                didParseCell: (data) => {
                    if (data.section === "head" && data.column.index === 0) {
                        data.cell.colSpan = 2;
                        data.cell.styles.halign = "left";
                    }
                },
                gapAfter: 8,
            });
        }

        // --------------------------------------------------------------
        // 8. SAVE
        // --------------------------------------------------------------
        doc.save(`Employee_Profile_${previewData?.givenName || "data"}.pdf`);

    };
    // Restrict the Submit Button
    const [sectionStatus, setSectionStatus] = useState({
        personal: false,
        address: false,
        education: false,
        bank: false,
        idDetails: false,
    });

    const validatePersonal = () => {
        return !!(
            previewData?.givenName &&
            previewData?.surname &&
            previewData?.gender?.gender &&
            previewData?.dateOfBirth &&
            previewData?.contactNumber &&
            previewData?.email &&
            previewData?.maritalStatus?.maritalStatus &&
            previewData?.nationality?.nationalityName &&
            previewData?.religion?.religionName
        );
    };

    const validateAddress = () => {
        if (!previewData?.addresses?.length) return false;
        const addr = previewData.addresses[0];
        return !!(
            addr.presentAddressLine1 &&
            addr.presentCountry &&
            addr.presentState &&
            addr.presentDistrict &&
            addr.presentPostCode &&
            addr.permanentAddressLine1 &&
            addr.permanentCountry &&
            addr.permanentState &&
            addr.permanentDistrict &&
            addr.permanentPostCode
        );
    };

    const validateEducation = () => {
        return previewData?.educations?.length > 0 &&
            previewData.educations.every(edu =>
                edu.qualification?.qualificationName
                //  &&
                // edu.degreeType?.degreeType 
            );
    };

    const validateBank = () => {
        return previewData?.bankDetails?.length > 0 &&
            previewData.bankDetails.every(bank =>
                bank.accountHolderName &&
                bank.accountNumber &&
                bank.accountType?.accountTypeName &&
                bank.ifscCode
            );
    };

    const validateIDDetails = () => {
        const id = previewData?.employeeIDDetails;
        return !!(
            id?.aadhaarNumber &&
            id?.nameAsPerAadhaar
        );
    };

    const updateSectionStatus = () => {
        setSectionStatus({
            personal: validatePersonal(),
            address: validateAddress(),
            education: validateEducation(),
            bank: validateBank(),
            idDetails: validateIDDetails(),
        });
    };
    const getMissingPersonalFields = () => {
        const missing = [];
        const data = previewData || {};

        if (!data.givenName) missing.push("Given Name");
        if (!data.surname) missing.push("Surname");
        if (!data.gender?.gender) missing.push("Gender");
        if (!data.dateOfBirth) missing.push("Date of Birth");
        if (!data.contactNumber) missing.push("Contact Number");
        if (!data.email) missing.push("Email");
        if (!data.maritalStatus?.maritalStatus) missing.push("Marital Status");
        if (!data.nationality?.nationalityName) missing.push("Nationality");
        if (!data.religion?.religionName) missing.push("Religion");
        // example: add more if needed (Father Name, Mother Name)
        if (!data.fatherName) missing.push("Father Name");
        if (!data.motherName) missing.push("Mother Name");

        return missing;
    };

    const getMissingAddressFields = () => {
        const missing = [];
        const addr = previewData?.addresses?.[0];

        if (!addr) return ["No address provided"];
        if (!addr.presentAddressLine1) missing.push("Present Address Line 1");
        if (!addr.presentCountry) missing.push("Present Country");
        if (!addr.presentState) missing.push("Present State");
        if (!addr.presentDistrict) missing.push("Present District");
        if (!addr.presentPostCode) missing.push("Present Post Code");
        if (!addr.permanentAddressLine1) missing.push("Permanent Address Line 1");
        if (!addr.permanentCountry) missing.push("Permanent Country");
        if (!addr.permanentState) missing.push("Permanent State");
        if (!addr.permanentDistrict) missing.push("Permanent District");
        if (!addr.permanentPostCode) missing.push("Permanent Post Code");

        return missing;
    };

    const getMissingEducationFields = () => {
        const missing = [];
        const educations = previewData?.educations || [];

        if (!educations.length) return ["No education record added"];

        educations.forEach((edu, index) => {
            if (!edu.qualification?.qualificationName)
                missing.push(`Qualification Name`);
            if (!edu.specializationResponse?.specializationName)
                missing.push(`Specialization Name`);

        });

        return missing;
    };

    const getMissingBankFields = () => {
        const missing = [];
        const banks = previewData?.bankDetails || [];

        if (!banks.length) return ["No bank details added"];

        banks.forEach((bank, index) => {
            if (!bank.accountHolderName)
                missing.push(`Account Holder Name`);
            if (!bank.accountNumber)
                missing.push(`Account Number`);
            if (!bank.accountType?.accountTypeName)
                missing.push(`Account Type`);
            if (!bank.ifscCode)
                missing.push(`IFSC Code`);
        });

        return missing;
    };

    const getMissingIDFields = () => {
        const missing = [];
        const id = previewData?.employeeIDDetails || {};

        if (!id.aadhaarNumber) missing.push("Aadhaar Number");
        if (!id.nameAsPerAadhaar) missing.push("Name as per Aadhaar");

        return missing;
    };

    // useEffect hook
    useEffect(() => {
        setSectionStatus({
            personal: getMissingPersonalFields().length === 0,
            address: getMissingAddressFields().length === 0,
            education: getMissingEducationFields().length === 0,
            bank: getMissingBankFields().length === 0,
            idDetails: getMissingIDFields().length === 0,
        });
    }, [previewData]);

    // For displaying missing details
    const missingFields = {
        personal: getMissingPersonalFields(),
        address: getMissingAddressFields(),
        education: getMissingEducationFields(),
        bank: getMissingBankFields(),
        idDetails: getMissingIDFields(),
    };

    //const allSectionsComplete = Object.values(sectionStatus).every(status => status === true);

    useEffect(() => {
        updateSectionStatus();
    }, [previewData]);

    const allSectionsComplete = Object.values(sectionStatus).every(status => status === true);


    // handle dialog button clicks
    const handleDialogYes = () => {
        handleDownloadPdf(); // your existing PDF download function
        navigate("/draft");
    };

    const handleDialogNo = () => {
        navigate("/draft");
    };
    return (
        <div className="preview-container">
            {/* <div className="preview-pdf">
                <button className="pdf-preview"
                    onClick={handleDownloadPdf}>Download PDF</button>
            </div> */}
            <form>
                <div className="previewdetails-heading"> <span className="highlight-label">Temporary ID : </span>
                    {employeeUniqueId} - {previewData?.givenName || ""} {previewData?.surname || ""} - {previewData?.employee?.jobPosition?.designationName || ""}
                </div>
                <div className="preview-content">
                    <div className="header-of-preview">
                        <h2 className="preview-title">Preview</h2>

                    </div>
                    <div className="span-tag">
                        {Object.values(sectionStatus).some(status => !status) && (
                            <span className="generic-warning">
                                * Please Enter Required Data Fields
                            </span>
                        )}

                        {!sectionStatus.personal && (
                            <div className="incomplete-section">
                                <div className="incomplete-msg">Personal Details Missing Fields:</div>
                                <ul>
                                    {missingFields.personal.map((f, i) => (
                                        <li key={i}>{f}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {!sectionStatus.address && (
                            <div className="incomplete-section">
                                <div className="incomplete-msg">Address Details Missing Fields:</div>
                                <ul>
                                    {missingFields.address.map((f, i) => (
                                        <li key={i}>{f}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {!sectionStatus.education && (
                            <div className="incomplete-section">
                                <div className="incomplete-msg">Education Details Missing Fields:</div>
                                <ul>
                                    {missingFields.education.map((f, i) => (
                                        <li key={i}>{f}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {!sectionStatus.bank && (
                            <div className="incomplete-section">
                                <div className="incomplete-msg">Bank Details Missing Fields:</div>
                                <ul>
                                    {missingFields.bank.map((f, i) => (
                                        <li key={i}>{f}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {!sectionStatus.idDetails && (
                            <div className="incomplete-section">
                                <div className="incomplete-msg">ID Details Missing Fields:</div>
                                <ul>
                                    {missingFields.idDetails.map((f, i) => (
                                        <li key={i}>{f}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>

                    {/* ====== Personal Info Table ====== */}
                    <table className="preview-table">
                        <thead className="preview-main-header">
                            <tr>
                                <th colSpan="4">Personal Details</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr>
                                <th className="label-cell">First Name</th>
                                <td>{previewData?.givenName}</td>
                                <th className="label-cell">Last Name</th>
                                <td>{previewData?.surname}</td>
                            </tr>

                            <tr>
                                <th className="label-cell">Gender</th>
                                <td>{previewData?.gender?.gender}</td>
                                <th className="label-cell">Date of Birth</th>
                                <td>{previewData?.dateOfBirth ? new Intl.DateTimeFormat("en-GB")
                                    .format(new Date(previewData.dateOfBirth))
                                    .replace(/\//g, "-")
                                    : "-"}</td>
                            </tr>

                            <tr>
                                <th className="label-cell">Mobile</th>
                                <td>{previewData?.contactNumber}</td>
                                <th className="label-cell">Email</th>
                                <td>{previewData?.email}</td>
                            </tr>

                            <tr>
                                <th className="label-cell">Marital Staus</th>
                                <td>{previewData?.maritalStatus?.maritalStatus}</td>

                                <th className="label-cell">Spouse contact Number</th>
                                <td>{previewData?.spouseContactNumber || "-"}</td>
                            </tr>
                            <tr>

                                <th className="label-cell">Spouse Given's Name</th>
                                <td>{previewData?.spouseName || "-"}</td>
                                <th className="label-cell">Spouse Surname</th>
                                <td>{previewData?.spouseSurname || '-'}</td>
                            </tr>

                            <tr>
                                <th className="label-cell">Father Given Name</th>
                                <td>{previewData?.fatherGivenName || '-'}</td>
                                <th className="label-cell">Father Surname</th>
                                <td>{previewData?.fatherSurname || '-'}</td>
                            </tr>
                            <tr>
                                <th className="label-cell">Mother Given Name</th>
                                <td>{previewData?.motherGivenName || '-'}</td>
                                <th className="label-cell">Mother Surname</th>
                                <td>{previewData?.motherSurname || '-'}</td>
                            </tr>
                            <tr>
                                <th className="label-cell">Father Mobile</th>
                                <td>{previewData?.fatherContactNumber || '-'}</td>
                                <th className="label-cell">Mother Mobile</th>
                                <td>{previewData?.motherContactNumber || '-'}</td>
                            </tr>

                            <tr>
                                <th className="label-cell">Nationality</th>
                                <td>{previewData?.nationality?.nationalityName}</td>
                                <th className="label-cell">Religion</th>
                                <td>{previewData?.religion?.religionName}</td>

                            </tr>

                            <tr>

                                <th className="label-cell">Reservation Category</th>
                                <td>{previewData?.reservationCategory?.categoryName}</td>
                                <th className="label-cell">Physically Handicapped</th>
                                <td>{previewData?.physicallyHandicapped ? 'Yes' : "No"}</td>
                            </tr>
                            <tr>

                                <th className="label-cell">Hearing Problem</th>
                                <td>{previewData?.hearingProblem ? 'Yes' : 'No'}</td>
                                <th className="label-cell">Visual Problem</th>
                                <td>{previewData?.visualProblem ? 'Yes' : 'No'}</td>

                            </tr>

                            <tr>

                                {['BC', 'BC-I', 'BC-II', 'EBC', 'EBC-I', 'EBC-II']
                                    .includes(previewData?.reservationCategory?.categoryName?.toUpperCase()) && (
                                        <>
                                            <th className="label-cell">Non-Creamy Layer</th>
                                            <td>{previewData?.isCreamyLayer ? 'Yes' : 'No'}</td>
                                        </>
                                    )}
                            </tr>
                        </tbody>
                    </table>

                    {/* ====== Address Table ====== */}
                    {previewData?.addresses?.length > 0 && (
                        <div>
                            <table className="preview-table">
                                <thead className="preview-main-header">
                                    <tr>
                                        <th colSpan="2">Present Address</th>
                                        <th colSpan="2">Permanent Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="label-cell">Address 1</td>
                                        <td>{previewData.addresses[0].presentAddressLine1}</td>
                                        <td className="label-cell">Address 1</td>
                                        <td>{previewData.addresses[0].permanentAddressLine1}</td>
                                    </tr>
                                    <tr>
                                        <td className="label-cell">Address 2</td>
                                        <td>{previewData.addresses[0].presentAddressLine2 || "-"}</td>
                                        <td className="label-cell">Address 2</td>
                                        <td>{previewData.addresses[0].permanentAddressLine2 || "-"}</td>
                                    </tr>
                                    <tr>
                                        <td className="label-cell">Country</td>
                                        <td>{previewData.addresses[0].presentCountry || '-'}</td>
                                        <td className="label-cell">Country</td>
                                        <td>{previewData.addresses[0].permanentCountry || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="label-cell">State</td>
                                        <td>{previewData.addresses[0].presentState || '-'}</td>
                                        <td className="label-cell">State</td>
                                        <td>{previewData.addresses[0].permanentState || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="label-cell">District</td>
                                        <td>{previewData.addresses[0].presentDistrict || '-'}</td>
                                        <td className="label-cell">District</td>
                                        <td>{previewData.addresses[0].permanentDistrict || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="label-cell">Block / Mandal</td>
                                        <td>{previewData.addresses[0].presentBlock || previewData.addresses[0].presentMandal}</td>
                                        <td className="label-cell">Block / Mandal</td>
                                        <td>{previewData.addresses[0].permanentBlock || previewData.addresses[0].permanentMandal}</td>
                                    </tr>
                                    <tr>
                                        <td className="label-cell">Pincode</td>
                                        <td>{previewData.addresses[0].presentPostCode || '-'}</td>
                                        <td className="label-cell">Pincode</td>
                                        <td>{previewData.addresses[0].permanentPostCode || '-'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}


                    {/* ====== Education Table ====== */}
                    {previewData?.educations?.length > 0 && (
                        <div>

                            <table className="preview-table">
                                <thead className="preview-main-header">
                                    <tr>
                                        <th colSpan="9">Education Details</th>
                                    </tr>
                                </thead>
                                <thead className="preview-subheader">
                                    <tr>
                                        <th>Qualification</th>
                                        <th>Degree / Examination</th>
                                        <th>Specializtion</th>
                                        <th>Institution Name</th>
                                        <th>Grade / Percentage</th>
                                        <th>Year of Passing</th>
                                        <th>Certificate</th>
                                        <th>Action</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {previewData.educations.map((edu) => (
                                        <tr key={edu.id}>
                                            <td>{edu.qualification?.qualificationName}</td>
                                            <td>{edu.degreeType?.degreeType || '-'}</td>
                                            <td>{edu.specializationResponse?.specializationName || '-'}</td>
                                            <td>{edu.institutionName || '-'}</td>
                                            <td>{edu.gradeOrPercentage || '-'}</td>
                                            <td>{edu.yearOfPassing || '-'}</td>
                                            <td>{getFileName(edu.certificate)}</td>
                                            <td>
                                                {edu.certificate ? (
                                                    <a
                                                        href={
                                                            edu.certificate.startsWith("http")
                                                                ? edu.certificate
                                                                : `${process.env.REACT_APP_FILE_BASE_URL}/${edu.certificate}`
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* ====== Other Certificates Table ====== */}
                    {previewData?.certificates?.length > 0 && (
                        <div>

                            <table className="preview-table">
                                <thead className="preview-main-header">
                                    <tr>
                                        <th colSpan="9">Other Certificates</th>
                                    </tr>
                                </thead>
                                <thead className="preview-subheader">
                                    <tr>
                                        <th>Certificate Name</th>
                                        <th>Certificate Number</th>
                                        <th>Issued Date</th>
                                        <th>Validate Date </th>
                                        <th>Certificate Name</th>
                                        <th>Action</th>
                                        {/* <th>Year of Passing</th>
                                        <th>Certificate</th> */}

                                    </tr>
                                </thead>
                                <tbody>
                                    {previewData.certificates.map((cert) => (
                                        <tr key={cert.id}>
                                            <td>{cert.certificateName}</td>
                                            <td>{cert.certificateNumber || '-'}</td>
                                            <td>{cert.issuedDate || '-'}</td>
                                            <td>{cert.validateDate || '-'}</td>
                                            {/* <td>{cert.gradeOrPercentage || '-'}</td>
                                            <td>{cert.yearOfPassing || '-'}</td> */}
                                            <td>{getFileName(cert.certificateFileName)}</td>
                                            <td>
                                                {cert.certificateFileName ? (
                                                    <a
                                                        href={
                                                            cert.certificateFileName.startsWith("http")
                                                                ? cert.certificateFileName
                                                                : `${process.env.REACT_APP_FILE_BASE_URL}/${cert.certificateFileName}`
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* ====== Experience Table ====== */}
                    {previewData?.experiences?.length > 0 && (
                        <div>
                            <table className="preview-table">
                                <thead className="preview-main-header">
                                    <tr>
                                        <th colSpan="2">Experience Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Loop through each experience and display the data */}
                                    {previewData.experiences.map((exp) => (
                                        <React.Fragment key={exp.id}>
                                            <tr>
                                                <th className="label-cell">Company Name</th>
                                                <td>{exp.companyName || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Designation</th>
                                                <td>{exp.designationName || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Skill Set</th>
                                                <td>{exp.skillSet || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">From Date</th>
                                                <td>
                                                    {exp.fromDate
                                                        ? new Intl.DateTimeFormat("en-GB").format(new Date(exp.fromDate)).replace(/\//g, "-")
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">To Date</th>
                                                <td>
                                                    {exp.toDate
                                                        ? new Intl.DateTimeFormat("en-GB").format(new Date(exp.toDate)).replace(/\//g, "-")
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Monthly Salary Drawn</th>
                                                <td>{exp.salaryDrawn || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Appointment Letter</th>
                                                <td>
                                                    {exp.appointmentLetter ? (
                                                        <>
                                                            <span>{getFileName(exp.appointmentLetter) || '-'}</span>
                                                            <span className="bank-image"> <a
                                                                href={
                                                                    exp.appointmentLetter.startsWith("http")
                                                                        ? exp.appointmentLetter
                                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${exp.appointmentLetter}`
                                                                }
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                View
                                                            </a></span>

                                                        </>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Relieving Letter</th>
                                                <td>
                                                    {exp.relievingLetter ? (
                                                        <>
                                                            <span>{getFileName(exp.relievingLetter) || '-'}</span>
                                                            <span className="bank-image"><a
                                                                href={
                                                                    exp.relievingLetter.startsWith("http")
                                                                        ? exp.relievingLetter
                                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${exp.relievingLetter}`
                                                                }
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                View
                                                            </a></span>

                                                        </>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}



                    {/* ====== Bank Table ====== */}
                    {previewData?.bankDetails && previewData.bankDetails.length > 0 && (
                        <div>
                            <table className="preview-table">
                                <thead className="preview-main-header">
                                    <tr>
                                        <th colSpan="6">Bank Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {previewData.bankDetails.map((bankDetail, index) => (
                                        <React.Fragment key={index}>
                                            <tr>
                                                <th className="label-cell">Name as per Bank Account</th>
                                                <td>{bankDetail.accountHolderName}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Account Number</th>
                                                <td>{bankDetail.accountNumber}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Account Type</th>
                                                <td>{bankDetail.accountType?.accountTypeName || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Bank Name</th>
                                                <td>{bankDetail.bankName || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Branch Name</th>
                                                <td>{bankDetail.branchName || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">IFSC Code</th>
                                                <td>{bankDetail.ifscCode}</td>
                                            </tr>
                                            <tr>
                                                <th className="label-cell">Passbook</th>
                                                <td>{getFileName(bankDetail.passbookFileName)}
                                                    <span className="bank-image">{bankDetail?.passbookFileName ? (
                                                        <a
                                                            href={bankDetail.passbookFileName.startsWith("http")
                                                                ? bankDetail.passbookFileName
                                                                : `${process.env.REACT_APP_FILE_BASE_URL}/${bankDetail.passbookFileName}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            View
                                                        </a>
                                                    ) : (
                                                        "-"
                                                    )}</span></td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}


                    {/* ====== Employee ID Details ====== */}
                    {previewData?.employeeIDDetails && (
                        <div>
                            <table className="preview-table">
                                <thead className="preview-main-header">
                                    <tr>
                                        <th colSpan="2">Employee ID Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th className="label-cell">Aadhaar Number</th>
                                        <td>{previewData.employeeIDDetails.aadhaarNumber}</td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">Name as per Aadhaar</th>
                                        <td>{previewData.employeeIDDetails.nameAsPerAadhaar}</td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">Aadhaar card photo</th>
                                        <td>{getFileName(previewData.employeeIDDetails.aadhaarFileName)}  <span className="bank-image">{previewData.employeeIDDetails?.aadhaarFileName ? (
                                            <a
                                                href={
                                                    previewData.employeeIDDetails.aadhaarFileName.startsWith("http")
                                                        ? previewData.employeeIDDetails.aadhaarFileName
                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.aadhaarFileName}`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "-"
                                        )}</span></td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">PAN Card Number</th>
                                        <td>{previewData.employeeIDDetails.panCardNumber || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">Name as per PAN</th>
                                        <td>{previewData.employeeIDDetails.nameAsPerPanCard || "-"}</td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">PAN card photo</th>
                                        <td>{getFileName(previewData.employeeIDDetails.panCardFileName)}  <span className="bank-image">{previewData.employeeIDDetails?.panCardFileName ? (
                                            <a
                                                href={
                                                    previewData.employeeIDDetails.panCardFileName.startsWith("http")
                                                        ? previewData.employeeIDDetails.panCardFileName
                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.panCardFileName}`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "-"
                                        )}</span></td>
                                    </tr>

                                    {/* ====== UAN & ESI Conditional Rendering ====== */}
                                    {(() => {
                                        const uan = previewData.employeeIDDetails?.hasUanNumber;
                                        const esi = previewData.employeeIDDetails?.hasEsiNumber;

                                        // Case 1: both false → show "Do you have..." only
                                        if (!uan && !esi) {
                                            return (
                                                <>
                                                    <tr>
                                                        <th className="label-cell">Do you have a UAN Number</th>
                                                        <td>No</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="label-cell">Do you have an ESI Number</th>
                                                        <td>No</td>
                                                    </tr>
                                                </>
                                            );
                                        }

                                        // Case 2: if UAN or ESI true → show actual details
                                        return (
                                            <>
                                                {uan && (
                                                    <>
                                                        <tr>
                                                            <th className="label-cell">UAN Number</th>
                                                            <td>{previewData.employeeIDDetails.uanNumber || "-"}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="label-cell">UAN Member ID</th>
                                                            <td>{previewData.employeeIDDetails.uanMemberId || "-"}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="label-cell">UAN card photo</th>
                                                            <td>{getFileName(previewData.employeeIDDetails.uanCardFileName)}  <span className="bank-image">{previewData.employeeIDDetails?.uanCardFileName ? (
                                                                <a
                                                                    href={
                                                                        previewData.employeeIDDetails.uanCardFileName.startsWith("http")
                                                                            ? previewData.employeeIDDetails.uanCardFileName
                                                                            : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.uanCardFileName}`
                                                                    }
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    View
                                                                </a>
                                                            ) : (
                                                                "-"
                                                            )}</span></td>
                                                        </tr>
                                                    </>
                                                )}
                                                {esi && (
                                                    <>
                                                        <tr>
                                                            <th className="label-cell">ESI Number</th>
                                                            <td>{previewData.employeeIDDetails.esiNumber || "-"}</td>
                                                        </tr>


                                                        <tr>
                                                            <th className="label-cell">ESI card photo</th>
                                                            <td>{getFileName(previewData.employeeIDDetails.esiCardFileName)}  <span className="bank-image">{previewData.employeeIDDetails?.esiCardFileName ? (
                                                                <a
                                                                    href={
                                                                        previewData.employeeIDDetails.esiCardFileName.startsWith("http")
                                                                            ? previewData.employeeIDDetails.esiCardFileName
                                                                            : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.esiCardFileName}`
                                                                    }
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    View
                                                                </a>
                                                            ) : (
                                                                "-"
                                                            )}</span></td>
                                                        </tr>
                                                    </>



                                                )}
                                            </>
                                        );
                                    })()}

                                    {/* ====== Nominee Details ====== */}
                                    <tr>
                                        <th className="label-cell">Nominee Name</th>
                                        <td>{previewData.employeeIDDetails.nomineeName || '-'}</td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">Relationship with Nominee</th>
                                        <td>{previewData.employeeIDDetails.nomineeRelationship?.relationshipName || '-'}</td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">Nominee Staying With You</th>
                                        <td>{previewData.employeeIDDetails.isNomineeStayingWithYou ? "Yes" : "No" || '-'}</td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">Father Id Proof</th>
                                        <td>{getFileName(previewData.employeeIDDetails.fatherIdProof)}  <span className="bank-image">{previewData.employeeIDDetails?.fatherIdProof ? (
                                            <a
                                                href={
                                                    previewData.employeeIDDetails.fatherIdProof.startsWith("http")
                                                        ? previewData.employeeIDDetails.fatherIdProof
                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.fatherIdProof}`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "-"
                                        )}</span></td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">Mother Id Proof</th>
                                        <td>{getFileName(previewData.employeeIDDetails.motherIdProof)}  <span className="bank-image">{previewData.employeeIDDetails?.motherIdProof ? (
                                            <a
                                                href={
                                                    previewData.employeeIDDetails.motherIdProof.startsWith("http")
                                                        ? previewData.employeeIDDetails.motherIdProof
                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.motherIdProof}`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "-"
                                        )}</span></td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">Spouse Id Proof</th>
                                        <td>{getFileName(previewData.employeeIDDetails.spouseIdProof)}  <span className="bank-image">{previewData.employeeIDDetails?.spouseIdProof ? (
                                            <a
                                                href={
                                                    previewData.employeeIDDetails.spouseIdProof.startsWith("http")
                                                        ? previewData.employeeIDDetails.spouseIdProof
                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.spouseIdProof}`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "-"
                                        )}</span></td>
                                    </tr>
                                    <tr>
                                        <th className="label-cell">physicallyHandicapped Certificate</th>
                                        <td>{getFileName(previewData.employeeIDDetails.pwdCertificate)}  <span className="bank-image">{previewData.employeeIDDetails?.pwdCertificate ? (
                                            <a
                                                href={
                                                    previewData.employeeIDDetails.pwdCertificate.startsWith("http")
                                                        ? previewData.employeeIDDetails.pwdCertificate
                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.pwdCertificate}`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "-"
                                        )}</span></td>
                                    </tr>

                                    <tr>
                                        <th className="label-cell">Employee Passport Size Photo</th>
                                        <td>{getFileName(previewData.employeeIDDetails.employeepassportSizeFileName)}  <span className="bank-image">{previewData.employeeIDDetails?.employeepassportSizeFileName ? (
                                            <a
                                                href={
                                                    previewData.employeeIDDetails.employeepassportSizeFileName.startsWith("http")
                                                        ? previewData.employeeIDDetails.employeepassportSizeFileName
                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.employeepassportSizeFileName}`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "-"
                                        )}</span></td>
                                    </tr>

                                    {['BC', 'BC-I', 'BC-II', 'EBC', 'EBC-I', 'EBC-II']
                                        .includes(previewData?.reservationCategory?.categoryName?.toUpperCase()) && (
                                            <tr>
                                                <th className="label-cell">Non-Creamy Layer Certificate</th>
                                                <td>
                                                    {getFileName(previewData?.employeeIDDetails?.creamyLayerFile)}
                                                    <span className="bank-image">
                                                        {previewData?.employeeIDDetails?.creamyLayerFile ? (
                                                            <a
                                                                href={
                                                                    previewData.employeeIDDetails.creamyLayerFile.startsWith("http")
                                                                        ? previewData.employeeIDDetails.creamyLayerFile
                                                                        : `${process.env.REACT_APP_FILE_BASE_URL}/${previewData.employeeIDDetails.creamyLayerFile}`
                                                                }
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                View
                                                            </a>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </span>
                                                </td>
                                            </tr>
                                        )}


                                </tbody>
                            </table>
                        </div>
                    )}



                    {/* Email Verification */}
                    <div className="preview-verify-box">
                        <div className="preview-otp-box">
                            <div className="preview-floating-label">
                                <input
                                    type="email"
                                    value={previewData?.email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    placeholder=" "
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                    title="Please enter a valid email address"
                                    disabled={verified} // disabled once verified
                                />
                                <label>
                                    <span className="required">*</span>Email
                                </label>
                            </div>

                            {!verified ? (
                                <button
                                    className="preview-btn"
                                    onClick={sendEmailOtp}
                                    disabled={emailTimer > 0}
                                >
                                    {emailTimer > 0 ? `Resend in ${emailTimer}s` : "Get OTP"}
                                </button>
                            ) : (
                                <span className="verified-badge">Verified✅</span>
                            )}
                        </div>

                        {/* OTP input only if not verified */}
                        {emailSent && !verified && (
                            <div className="preview-otp-box">
                                <div className="preview-floating-label">
                                    <input
                                        type="text"
                                        value={emailOtp}
                                        onChange={(e) => setEmailOtp(e.target.value)}
                                        required
                                        placeholder=" "
                                    />
                                    <label>Email OTP</label>
                                </div>
                                <button className="preview-btn" onClick={verifyEmailOtp}>
                                    Verify
                                </button>
                            </div>
                        )}
                    </div>


                    <div className="check-valid">
                        <input
                            type="checkbox"
                            id="agree-checkbox"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)}
                        />
                        <label htmlFor="agree-checkbox">I agree to the terms and conditions</label>
                    </div>




                    <div className="preview-sbt">
                        <button className="preview-pevious" onClick={onPrevious}> Previous</button>
                        <button type="button" className="preview-pevious" onClick={handleSubmit}
                            disabled={!(verified && isChecked && allSectionsComplete)}
                        >
                            Submit
                        </button>

                    </div>
                </div>
                {showSaveSuccess && (
                    <div className="confirm-overlay">
                        <div className="success-message-popup">
                            <p>{successMessage}</p>
                            <div className="dialog-buttons">
                                <button className="yes-btn" onClick={handleDialogYes}>Yes</button>
                                <button className="no-btn" onClick={handleDialogNo}>No</button>
                            </div>
                        </div>
                    </div>
                )}

            </form>


        </div>
    );
};

export default PreviewPage;
